import {
  SET_SHOULD_FETCH_ESSENTIAL_DATA,
  SET_ACTION_STATUS,
  RESET_ACTION_STATUSES,
  SET_LAST_SYNC_TIMESTAMP,
} from 'constants/essentialData';
import { Status } from 'containers/EssentialDataLoader/types';

export function setShouldFetchEssentialData(payload: boolean) {
  return {
    type: SET_SHOULD_FETCH_ESSENTIAL_DATA,
    payload,
  };
}

export function setActionStatus<T>(key: T, status: Status, error?: string) {
  return {
    type: SET_ACTION_STATUS,
    payload: { key, status, error },
  };
}

export function resetActionStatuses() {
  return {
    type: RESET_ACTION_STATUSES,
  };
}

export function setLastSyncTimestamp(timestamp: number) {
  return {
    type: SET_LAST_SYNC_TIMESTAMP,
    payload: timestamp,
  };
}
